import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  padding: 1rem;

  .cardWrapper {
    box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%),
      0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);

    border-radius: 0.2rem;

    padding: 1.5rem;
    margin: 1rem 0;

    font-size: 1.3rem;
  }
`;

export const WrapperHeader = styled.hgroup`
  display: flex;
  align-items: center;
  justify-content: space-between;

  color: #3f51b5;

  font-weight: 700;
`;

export const Infos = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.3rem;

  margin: 1rem 0;

  li {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    p {
      margin-right: 1rem;
    }

    span {
      color: #fff;
      background-color: #333;

      border-radius: 0.2rem;

      padding: 0 1rem;
    }
  }
`;

export const Progress = styled.div`
  ${({ filled, full }) => css`
    width: 100%;
    height: 2rem;

    background-color: transparent;

    border-width: 0.1rem;
    border-style: solid;
    border-color: #666;

    position: relative;

    user-select: none;

    border-radius: 0.2rem;

    &:before {
      content: '';

      position: absolute;

      top: 0;
      left: 0;

      width: ${((filled * 100) / full).toFixed(2)}%;
      height: calc(2rem - 0.2rem);

      max-width: 100%;

      z-index: 9;

      background-color: #3f51b5;
    }
  `}
`;

export const Programming = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 1rem;

  span {
    color: #fff;
    background-color: #333;

    border-radius: 0.2rem;

    padding: 0 0.5rem;

    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Product = styled.div`
  width: 100%;

  padding: 0 0.5rem;
  margin-bottom: 1rem;

  color: #fff;
  background-color: #333;

  border-radius: 0.2rem;
`;

export const InfoProgramming = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    color: #fff;
    background-color: #333;

    border-radius: 0.2rem;

    padding: 0 0.5rem;
    margin-left: 0.5rem;
  }
`;

export const Charging = styled.ul`
  margin-bottom: 1rem;

  display: flex;
  flex-direction: column;

  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);

  padding: 1.5rem;

  border-radius: 0.2rem;

  li {
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      color: #fff;
      background-color: #333;

      border-radius: 0.2rem;

      padding: 0 1rem;
    }

    & + li {
      margin-top: 0.5rem;
    }
  }

  li.product__name {
    background-color: #333;
    color: #fff;

    text-transform: uppercase;

    padding: 0 1rem;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    border-radius: 0.2rem;
  }

  & + ul {
    margin-top: 1rem;
  }
`;
